import { Component, Input } from '@angular/core';
import { Purchase } from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { ClassNames, Color, Size } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';

@Component({
    selector: 'purchases-funding-total-popover',
    template: `
        <div [ngStyle]="{ 'text-align': isMobile ? 'left' : 'right' }">
            <span>{{ row.fundingAmount | currencyDash }}</span>
            <popover-content #fundingPopover [size]="size.MediumSmall">
                <table class="expense-popover">
                    <tbody>
                        <tr>
                            <td i18n="funding total popover label amount">Amount</td>
                            <td>{{ row.purchaseAmount | currency }}</td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label denied">Denied</td>
                            <td>
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    {{ row.deniedAmount | currency }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label ineligibles">Ineligibles</td>
                            <td>
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    <!-- Not available for historical data that will return null. -->
                                    {{
                                        row.ineligibleAmount || row.ineligibleAmount === 0
                                            ? (row.ineligibleAmount | currency)
                                            : 'Not Available'
                                    }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label over credit limit">
                                Over Credit Limit
                            </td>
                            <td class="bordered">
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    <!-- Not available for historical data that will return null. -->
                                    {{
                                        row.overCreditLimitAmount || row.overCreditLimitAmount === 0
                                            ? (row.overCreditLimitAmount | currency)
                                            : 'Not Available'
                                    }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label eligible AR">Eligible AR</td>
                            <td>{{ row.eligibleAr | currency }}</td>
                        </tr>
                        <tr>
                            <td>
                                <div i18n="funding total popover label required reserves">
                                    Required Reserves
                                </div>
                                <small
                                    ><small
                                        i18n="
                                            funding total popover label required reserves
                                            calculation eligible AR text
                                        "
                                        >Eligible AR</small
                                    >
                                    *
                                    {{
                                        row.advanceRate
                                            ? ((100 - row.advanceRate) / 100 | percent)
                                            : ''
                                    }}</small
                                >
                            </td>
                            <td>
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    {{ row.requiredReserves | currency }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label fees">Fees</td>
                            <td>
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    {{ row.purchaseFees | currency }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label expenses">Expenses</td>
                            <td class="bordered">
                                <div>
                                    <lsq-icon [type]="icons.MinusSign" color="black"></lsq-icon>
                                    {{
                                        (row.expenseBreakdown &&
                                        row.expenseBreakdown.totalExpenses > 0
                                            ? row.expenseBreakdown.totalExpenses
                                            : 0
                                        ) | currency
                                    }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td i18n="funding total popover label available funds">
                                Available Funds
                            </td>
                            <td>{{ row.fundingAmount | currency }}</td>
                        </tr>
                    </tbody>
                </table>
            </popover-content>
            <lsq-icon
                *ngIf="row.purchaseAmount"
                [type]="icons.Info"
                [color]="color.Gray"
                [ngClass]="[classNames.TableCellPopoverIcon, classNames.PopoverIcon]"
                [popover]="fundingPopover"
                [popoverPlacement]="placement.BottomLeft"
            >
            </lsq-icon>
        </div>
    `
})
export class PurchasesFundingTotalPopoverComponent {
    @Input() public row: Purchase;
    @Input() public isMobile = false;

    public classNames = ClassNames;
    public placement = PopoverPlacement;
    public icons = Icons;
    public color = Color;
    public size = Size;
}
